import { useMemo } from 'react'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { isLabTierUpgradeCampaignPayload } from 'loyalty/tierUpgradeCampaign/tierUpgradeCampaignTypes'

function useTierUpgradeCampaign(slug: string): App.TierUpgradeCampaignPayload | undefined {
  const flag = useLabFeatureFlag(LabFeatureFlags.enableTierUpgradeCampaign)

  return useMemo(() => {
    if (!flag?.enabled) return undefined

    // Legacy format: flag.value is the campaign payload directly
    if (!Array.isArray(flag.value)) {
      if (!isLabTierUpgradeCampaignPayload(flag.value)) return undefined
      if (flag.value.slug !== slug) return undefined
      return flag.value
    }

    // New format: flag.value is an array of campaign entries
    for (const entry of flag.value) {
      if (!entry?.enabled) continue
      if (!isLabTierUpgradeCampaignPayload(entry.value)) continue
      if (entry.value.slug !== slug) continue
      return entry.value
    }

    return undefined
  }, [flag, slug])
}

export default useTierUpgradeCampaign
